var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"groups"}},[_c('div',{staticClass:"au-main-container-building"},[_c('roles-users-table',{attrs:{"app-settings":"","specificGroups":"","manage-groups-type":"","allowAppEdit":!_vm.readonly}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }